import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { VesselsService } from '../../vessels.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-voyage-toolbar',
  templateUrl: './voyage-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AuthenticationModule, MatButtonModule]
})
export class VoyageToolbarComponent {
  @Output() addDocument: EventEmitter<string> = new EventEmitter();

  _currentVoyageId!: string;
  get currentVoyageId() {
    return this._currentVoyageId;
  }
  set currentVoyageId(voyageId: string) {
    this._currentVoyageId = voyageId;
    this._vesselsService.findPreviousVoyageId(voyageId).subscribe(previousId => {
      this.previousVoyageId = previousId!;
    }, () => {
      this.previousVoyageId = '';
    });

    this._vesselsService.findNextVoyageId(voyageId).subscribe(nextVoyageId => {
      this.nextVoyageId = nextVoyageId!;
    }, () => {
      this.nextVoyageId = '';
    });
  }
  previousVoyageId = '';
  nextVoyageId = '';

  constructor(private _router: Router,
              private _vesselsService: VesselsService,
  ) { }

  navigateToVoyage(voyageId: string) {
    this._router.navigate(['vessels/voyage', voyageId]).then();
  }

  navigateToVoyageWithTimestamp(voyageId: string) {
    this._router.navigate(['vessels/voyage', voyageId], {
      queryParams: {
        t: new Date().getTime()
      }
    }).then();
  }

  showAddDocument(documentType: string) {
    this.addDocument.next(documentType);
  }
}
